<template>
  <div>
    <CLAlert
      :show="alert.status"
      :color="alert.color"
      :message="alert.message"
    />

    <div class="container-fluid p-0" id="order-reports">
      <div class="row">
        <div class="col-auto">
          <CLHeader
            mainTopic="Callia new labels:"
            subTopic="EDM, BC, CG, TR & MB NEW LABELS -- TEST"
          />
        </div>
      </div>

      <div class="row mt-3 mb-0 form">
        <div class="col-md-8 col-xl-6 col-12">
          <div class="form-card">
            <b-form id="order-report-form">
              <b-form-group>
                <label class="mt-2 report-label">Labels file name</label>
                <b-form-input
                  v-model="form.fileName"
                  type="text"
                  @keyup="validateFileName"
                  placeholder="exportFileName"
                  class="input-height mt-1"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                class="mb-0 report-label"
                label="Driver Initials"
                v-slot="{ ariaOnfleet }"
              >
                <b-form-radio
                  v-model="form.onfleet"
                  :aria-describedby="ariaOnfleet"
                  name="onfleetRadio"
                  value="1"
                >
                  Needs Driver Initials/OnFleet Deliveries
                </b-form-radio>
                <b-form-radio
                  v-model="form.onfleet"
                  :aria-describedby="ariaOnfleet"
                  name="onfleetRadio"
                  value="0"
                >
                  No driver initials/Courier deliveries
                </b-form-radio>
              </b-form-group>

              <b-form-group
                class="mb-0 report-label"
                label="Add pulled tags"
                v-slot="{ ariapulledTag }"
              >
                <b-form-checkbox
                  v-model="form.pulledTag"
                  :aria-describedby="ariapulledTag"
                  name="pulledTag"
                  value="1"
                >
                  Add pulled tags
                </b-form-checkbox>
              </b-form-group>

              <b-form-group>
                <label class="mt-2 report-label">Excel file</label>
                <b-form-file
                  placeholder="Choose a file"
                  class="input-height"
                  @change="onFileChange"
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <label class="mt-2 report-label">Send email to</label>
                <b-form-select
                  v-model="form.email"
                  :options="emailsOpt"
                  class="input-height mt-1"
                ></b-form-select>
              </b-form-group>
              <b-form-group>
                <label class="mt-2 report-label">Email subject</label>
                <b-form-input
                  v-model="form.subject"
                  type="text"
                  placeholder="Email subject"
                  class="input-height mt-1"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label class="mt-2 report-label">Email body</label>
                <b-form-textarea
                  id="textarea"
                  v-model="form.body"
                  placeholder="Email body"
                  rows="3"
                  max-rows="100"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group>
                <label class="mt-2 report-label">Email attachment file</label>
                <b-form-file
                  v-model="attachment"
                  placeholder="Choose a file for attachment"
                  class="input-height"
                  @change="onAttachmentChange"
                ></b-form-file>
              </b-form-group>

              <b-form-group
                class="mb-0 report-label"
                label="Waybill Processing: export a single 4×6″ print-ready file"
                v-slot="{ ariaWaybillProcessing }"
              >
                <b-form-checkbox
                  v-model="form.processWaybillPdf"
                  :aria-describedby="ariaWaybillProcessing"
                  name="processWaybillPdf"
                  value="1"
                  @change="onWaybillCheckboxChange"
                >
                  Waybill Cropper
                </b-form-checkbox>
              </b-form-group>

              <div
                v-if="processingState.isProcessing"
                class="mt-3 processing-alert"
              >
                <div
                  class="alert alert-info alert-dismissible fade show"
                  role="alert"
                >
                  <div class="d-flex align-items-center">
                    <div
                      class="spinner-border spinner-border-sm mr-2"
                      role="status"
                    >
                      <span class="sr-only">Processing...</span>
                    </div>
                    <div class="flex-grow-1">
                      <strong>Processing PDF:</strong>
                      <p class="mb-1">{{ processingState.message }}</p>
                      <div class="progress" style="height: 5px;">
                        <div
                          class="progress-bar"
                          role="progressbar"
                          :style="{ width: processingState.progress + '%' }"
                          :aria-valuenow="processingState.progress"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="hasErrors" class="mt-3 error-alerts">
                <div
                  v-for="(error, index) in errorMessages"
                  :key="index"
                  class="alert alert-warning alert-dismissible fade show"
                  role="alert"
                >
                  {{ error }}
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="alert"
                    aria-label="Close"
                  ></button>
                </div>
              </div>

              <div v-if="processedPdfUrl" class="row mt-4">
                <div class="col-12">
                  <div class="preview-card">
                    <div
                      class="d-flex justify-content-between align-items-center mb-3"
                    >
                      <div>
                        <h5 class="mb-0">Cropped PDF Preview</h5>
                        <small class="text-muted"
                          >Preview is generated in the browser from the
                          processed file.</small
                        >
                      </div>
                      <button
                        type="button"
                        class="btn btn-secondary btn-sm"
                        @click="downloadProcessedPdf"
                      >
                        Download cropped PDF
                      </button>
                    </div>
                    <div class="pdf-preview-wrapper">
                      <iframe
                        :src="processedPdfUrl"
                        class="pdf-preview-iframe"
                        frameborder="0"
                        aria-label="Processed PDF preview"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>

              <b-form-group>
                <CLButton
                  class="mt-3"
                  format="primary-btn"
                  v-on:func="onSubmit"
                  :disabled="!submitBtnValidate || showProgress"
                >
                  Export file
                </CLButton>
              </b-form-group>

              <div v-if="showProgress" class="progress-flex">
                <div class="progress-container">
                  <CLProgress :value="progressBarWidth" animated />
                  <p class="mt-2 text-center">Exporting file. Please wait</p>
                </div>
              </div>

              <b-form-group>
                <label class="mt-2 report-label">Result</label>
                <b-form-textarea
                  v-model="form.result"
                  rows="5"
                  max-rows="8"
                  plaintext
                  class="mt-1"
                ></b-form-textarea>
              </b-form-group>
            </b-form>
          </div>
        </div>
      </div>
    </div>
    <div class="page-break"></div>
  </div>
</template>
<script>
import LabelsMixin from "@/mixin/labels-mixin";
import { useWaybillProcessor } from "@/composables/useWaybillProcessor";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
import { CLProgress, CLHeader, CLButton, CLAlert } from "callia-ui-box";
import { v4 as uuid } from "uuid";
import * as XLSX from "xlsx";

export default {
  mixins: [LabelsMixin],
  components: {
    CLProgress,
    CLHeader,
    CLButton,
    CLAlert
  },
  setup() {
    return {
      ...useWaybillProcessor()
    };
  },
  data() {
    return {
      labelsEndpoint: "https://labels.calliaops.com/",
      // labelsEndpoint: 'http://localhost/',
      /** initialize form fields */
      form: {
        /** initialize upload unique process id */
        processId: uuid(),
        fileName: "",
        result: "",
        pagesNum: 10,
        onfleet: 1,
        pulledTag: 0,
        maxSize: "50",
        email: "",
        subject: "",
        body: "",
        processWaybillPdf: false
      },
      emailsOpt: [
        { text: "No email", value: "" },
        {
          text: "banfforders@calliaflowers.com",
          value: "banfforders@calliaflowers.com"
        },
        {
          text: "calgaryorders@calliaflowers.com",
          value: "calgaryorders@calliaflowers.com"
        },
        {
          text: "edmontonorders@calliaflowers.com",
          value: "edmontonorders@calliaflowers.com"
        },
        {
          text: "halifaxorders@calliaflowers.com",
          value: "halifaxorders@calliaflowers.com"
        },
        {
          text: "kelownaorders@calliaflowers.com",
          value: "kelownaorders@calliaflowers.com"
        },
        {
          text: "kingstonorders@calliaflowers.com",
          value: "kingstonorders@calliaflowers.com"
        },
        {
          text: "kitchenerorders@calliaflowers.com",
          value: "kitchenerorders@calliaflowers.com"
        },
        {
          text: "lethbridgeorders@calliaflowers.com",
          value: "lethbridgeorders@calliaflowers.com"
        },
        {
          text: "londonorders@calliaflowers.com",
          value: "londonorders@calliaflowers.com"
        },
        {
          text: "maritimesorders@calliaflowers.com",
          value: "maritimesorders@calliaflowers.com"
        },
        {
          text: "montrealorders@calliaflowers.com",
          value: "montrealorders@calliaflowers.com"
        },
        {
          text: "northernalbertaorders@calliaflowers.com",
          value: "northernalbertaorders@calliaflowers.com"
        },
        {
          text: "okanaganorders@calliaflowers.com",
          value: "okanaganorders@calliaflowers.com"
        },
        {
          text: "oshawaorders@calliaflowers.com",
          value: "oshawaorders@calliaflowers.com"
        },
        {
          text: "ottawaorders@calliaflowers.com",
          value: "ottawaorders@calliaflowers.com"
        },
        {
          text: "quebeccityorders@calliaflowers.com",
          value: "quebeccityorders@calliaflowers.com"
        },
        {
          text: "reginaorders@calliaflowers.com",
          value: "reginaorders@calliaflowers.com"
        },
        {
          text: "saskatoonorders@calliaflowers.com",
          value: "saskatoonorders@calliaflowers.com"
        },
        {
          text: "southernalbertaorders@calliaflowers.com",
          value: "southernalbertaorders@calliaflowers.com"
        },
        {
          text: "torontoorders@calliaflowers.com",
          value: "torontoorders@calliaflowers.com"
        },
        {
          text: "vancouverorders@calliaflowers.com",
          value: "vancouverorders@calliaflowers.com"
        },
        {
          text: "victoriaorders@calliaflowers.com",
          value: "victoriaorders@calliaflowers.com"
        },
        {
          text: "winnipegorders@calliaflowers.com",
          value: "winnipegorders@calliaflowers.com"
        },
        {
          text: "lila@lakewood-florist.ca",
          value: "lila@lakewood-florist.ca"
        },
        {
          text: "huaijun@calliaflowers.com",
          value: "huaijun@calliaflowers.com"
        },
        {
          text: "caitlin@calliaflowers.com",
          value: "caitlin@calliaflowers.com"
        }
      ],
      /** initialize progress bar */
      progressBarWidth: 0,
      failedNum: 0,
      attachment: null,
      showProgress: false,
      /** initialize alert box */
      alert: {
        status: false,
        color: "",
        message: ""
      },
      processedPdfUrl: null,
      processedPdfFileName: ""
    };
  },
  created() {
    Object.defineProperty(this, "$_excelFile", {
      value: null,
      writable: true,
      configurable: true,
      enumerable: false
    });
    Object.defineProperty(this, "$_attachmentFile", {
      value: null,
      writable: true,
      configurable: true,
      enumerable: false
    });
  },
  beforeUnmount() {
    if (this.processedPdfUrl) {
      URL.revokeObjectURL(this.processedPdfUrl);
    }
  },
  methods: {
    /** Handle waybill PDF processing checkbox change */
    onWaybillCheckboxChange() {
      if (this.form.processWaybillPdf) {
        this.enableProcessing();
      } else {
        this.disableProcessing();
      }

      // Process waybill PDF if enabled
      if (
        this.form.processWaybillPdf &&
        this.$_attachmentFile &&
        this.$_attachmentFile.name
      ) {
        this.processAttachmentPdf();
      }
    },

    /**
     * Process attachment PDF if waybill processing is enabled
     * @returns {Promise<boolean>} True if processing succeeded or was skipped, false on error
     */
    async processAttachmentPdf() {
      // Skip processing if disabled or no attachment
      if (
        !this.form.processWaybillPdf ||
        !this.$_attachmentFile ||
        !this.$_attachmentFile.name
      ) {
        return true;
      }

      try {
        const processedFile = await this.processPdf(this.$_attachmentFile);

        if (processedFile) {
          // Replace original attachment with processed PDF
          this.$_attachmentFile = processedFile;
          this.clearProcessedPreview();
          // this.processedPdfFileName = processedFile.name;
          this.processedPdfFileName = `waybills-4x6-${dayjs()
            .tz("America/Winnipeg")
            .format("YYYY-MM-DD")}.pdf`;
          this.processedPdfUrl = URL.createObjectURL(processedFile);
          return true;
        } else {
          // Processing failed, but show error in alert
          this.alert = {
            color: "warning",
            message: this.processingState.error || "PDF processing failed",
            status: true
          };
          setTimeout(() => {
            this.alert.status = false;
          }, 5500);
          return false;
        }
      } catch (error) {
        console.error("Error in processAttachmentPdf:", error);
        this.alert = {
          color: "danger",
          message: "Unexpected error during PDF processing",
          status: true
        };
        setTimeout(() => {
          this.alert.status = false;
        }, 5500);
        return false;
      }
    },

    /** Handle file selection and parse Excel content */
    onFileChange(event) {
      const file = event.target.files[0];
      if (file && file.name.includes(".xlsx")) {
        this.$_excelFile = file;
        this.parseExcelFile(file);
      }
    },

    /** Handle attachment selection */
    onAttachmentChange(event) {
      const file = event.target.files && event.target.files[0];
      this.$_attachmentFile = file || null;
      this.clearProcessedPreview();
      // Process waybill PDF if enabled
      if (
        this.form.processWaybillPdf &&
        this.$_attachmentFile &&
        this.$_attachmentFile.name
      ) {
        this.processAttachmentPdf();
      }
    },

    /** Clear any generated processed PDF preview */
    clearProcessedPreview() {
      if (this.processedPdfUrl) {
        URL.revokeObjectURL(this.processedPdfUrl);
      }
      this.attachment = null;
      this.processedPdfUrl = null;
      this.processedPdfFileName = "";
    },

    /** Download the generated processed PDF */
    downloadProcessedPdf() {
      if (!this.processedPdfUrl) {
        return;
      }
      const link = document.createElement("a");
      link.href = this.processedPdfUrl;
      link.download = this.processedPdfFileName || "processed-waybill.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    /** Parse Excel file and log records length */
    parseExcelFile(file) {
      const reader = new FileReader();
      reader.onload = e => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });

          // Get the first worksheet
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          // Convert to JSON to get records
          const jsonData = XLSX.utils.sheet_to_json(worksheet);

          console.log("Excel file parsed successfully");
          console.log("Records length:", jsonData.length);
          console.log("Sample data (first 3 records):", jsonData.slice(0, 3));

          const orderNumber =
            jsonData.length > 1
              ? `${jsonData.length} Callia orders`
              : `${jsonData.length} Callia order`;
          const deliveryDateObj = dayjs(
            jsonData[0]["Delivery Date"],
            "MM/DD/YYYY"
          );
          const deliveryDate = deliveryDateObj.format("MMM D");
          const region = jsonData[0]["Region"];

          // Calculate variant type based on delivery date comparison with today
          const today = dayjs().startOf("day");
          const deliveryDay = deliveryDateObj.startOf("day");
          const daysDifference = deliveryDay.diff(today, "day");

          let variantType = "";
          let dateText = deliveryDate;
          if (daysDifference === 0) {
            variantType = "SD"; // Same Day
            dateText = "today";
          } else if (daysDifference === 1) {
            variantType = "ND"; // Next Day
            dateText = "tomorrow";
          } else if (daysDifference === 2) {
            variantType = "ND+1"; // Next Day + 1
            dateText = "the day after tomorrow";
          } else if (daysDifference === 3) {
            variantType = "ND+2"; // Next Day + 2
          } else if (daysDifference > 3) {
            variantType = `ND+${daysDifference - 1}`; // Next Day + X
          } else {
            variantType = "PAST"; // Past date
          }

          const shortName = this.getShortByRegion(region) || region;
          const emailSubject = `${orderNumber} | ${deliveryDate} | ${shortName} ${variantType}`;
          console.log(emailSubject);
          this.form.subject = emailSubject;

          // const orderNumbers = jsonData.map(row => row["Task_Details"]).filter(Boolean);
          // const emailBody = `Hey team, ${orderNumber} for ${dateText}.\n\nOrder numbers:\n${orderNumbers.join(", ")}\n\nThanks a bunch!`;
          const emailBody = `Hey team, ${orderNumber} for ${dateText}.\nThanks a bunch!`;
          this.form.body = emailBody;

          // Auto-select email based on region
          const selectedEmail = this.getEmailByRegion(region);
          if (selectedEmail) {
            this.$nextTick(() => {
              this.form.email = selectedEmail;
              console.log(
                `Auto-selected email: ${selectedEmail} for region: ${region}`
              );
            });
          }

          console.log(
            `Days difference from today: ${daysDifference} (${variantType})`
          );
        } catch (error) {
          console.error("Error parsing Excel file:", error);
          this.alert = {
            color: "warning",
            message: "Error parsing Excel file. Please check the file format.",
            status: true
          };
          setTimeout(() => {
            this.alert.status = false;
          }, 5500);
        }
      };
      reader.readAsArrayBuffer(file);
    },
    /** form submit event */
    async onSubmit() {
      await this.excelToPdfExporter();
    },
    /** form filed validation */
    validateFileName(event) {
      const string = event.target.value;
      this.form.fileName = string.replace(/\s+/g, "_");
    },
    validateMaxSize(event) {
      const maxsize = event.target.value;
      if (!maxsize.match(/^[1-9]+[0-9]*$/g)) {
        this.form.maxSize = "";
      }
    },
    /** excel to pdf upload main handler */
    async excelToPdfExporter() {
      this.form.result = "";
      this.alert.status = false;
      this.progressBarWidth = 0;
      this.failedNum = 0;
      this.showProgress = true;

      this.form.processId = uuid();
      console.log("processId:", this.form.processId);

      // // Process waybill PDF if enabled
      // if (this.form.processWaybillPdf && this.$_attachmentFile && this.$_attachmentFile.name) {
      //   const processingSucceeded = await this.processAttachmentPdf();
      //   if (!processingSucceeded) {
      //     this.showProgress = false;
      //     return;
      //   }
      // }

      // Convert file to base64
      const fileBase64 = await this.fileToBase64(this.$_excelFile);

      const payload = {
        processId: this.form.processId,
        exportFileName: this.form.fileName,
        pagesNum: this.form.pagesNum,
        onfleet: this.form.onfleet,
        pulledTag: this.form.pulledTag,
        maxSize: this.form.maxSize,
        file: fileBase64,
        fileName: this.$_excelFile.name,
        email: this.form.email,
        subject: this.form.subject,
        body: this.form.body
      };

      // Convert attachment to base64 if exists
      if (this.$_attachmentFile && this.$_attachmentFile.name) {
        payload.attachment = await this.fileToBase64(this.$_attachmentFile);
        payload.attachmentName = this.processedPdfFileName;
      }

      const url = process.env.VUE_APP_API_ADMIN_API_ENDPOINT + "/labels/upload";
      await this.axios({
        method: "post",
        url: url,
        // url: this.labelsEndpoint + "labels/upload",
        headers: {
          "Content-Type": "application/json"
        },
        data: payload
      })
        .then(response => {
          this.loadProgressBar();
        })
        .catch(error => {
          console.log("error:", error);
          this.alert = {
            color: "warning",
            message: "File exported failed!",
            status: true
          };
          setTimeout(() => {
            this.alert.status = false;
          }, 5500);
        });
    },
    /** Convert file to base64 string */
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          // Remove the data URL prefix (e.g., "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,")
          const base64String = reader.result.split(",")[1];
          resolve(base64String);
        };
        reader.onerror = error => reject(error);
      });
    },
    /** form refresh */
    refreshPage() {
      this.showProgress = false;
      this.progressBarWidth = 0;
      this.failedNum = 0;
      this.alert.status = false;
      this.form.fileName = "";
      this.form.pagesNum = 10;
      this.form.onfleet = 1;
      this.form.pulledTag = 0;
      this.form.maxSize = "300";
      this.$_excelFile = null;
      this.form.email = "";
      this.form.subject = "";
      this.form.body = "";
      this.$_attachmentFile = null;
      this.form.processWaybillPdf = false;
      this.form.processId = uuid();
      this.attachment = null;
      this.clearProcessedPreview();
      this.reset();
    },
    /** Load progressbar and calculate progress event  */
    async loadProgressBar() {
      let tempProgressValue = 0;
      this.progressBarWidth = tempProgressValue;
      console.log("loadProgressBar processId:", this.form.processId);
      const progressRunner = setInterval(() => {
        this.axios
          .get(
            process.env.VUE_APP_API_ADMIN_API_ENDPOINT +
              "/labels/query/" +
              this.form.processId
          )
          .then(response => {
            if (!response.data.process_id) {
              if (this.failedNum > 5) {
                this.alert = {
                  color: "warning",
                  message: "Labels generation failed",
                  status: true
                };
                setTimeout(() => {
                  this.alert.status = false;
                }, 5500);
                clearInterval(progressRunner);
                this.showProgress = false;
                return;
              }
              this.failedNum++;
            }
            const percentage = parseFloat(response.data.percentage);
            if (percentage < 0) {
              if (this.failedNum > 5) {
                clearInterval(progressRunner);
                console.log("clearInterval. percentage:", percentage);
                this.showProgress = false;
              }
              this.failedNum++;
            } else {
              if (percentage == 100) {
                clearInterval(progressRunner);
                this.showProgress = false;
                this.refreshPage();
                this.alert = {
                  color: "success",
                  message: "File exporting successfully done",
                  status: true
                };
                setTimeout(() => {
                  this.alert.status = false;
                }, 5500);
              } else {
                // if (parseInt(this.progressBarWidth) < 100) {
                //   this.progressBarWidth += 1
                // }
              }
              if (tempProgressValue < percentage) {
                this.progressBarWidth = percentage;
              }
              tempProgressValue = this.progressBarWidth;
            }
            if (response.data.message) {
              this.form.result = response.data.message;
              if (response.data.message.startsWith("Cannot")) {
                if (this.failedNum > 5) {
                  this.refreshPage();
                  this.alert = {
                    color: "warning",
                    message: "Labels generation failed",
                    status: true
                  };
                  setTimeout(() => {
                    this.alert.status = false;
                  }, 5500);
                  clearInterval(progressRunner);
                  this.showProgress = false;
                }
              }
            } else {
              this.form.result = "";
            }
            if (response.data.excel_remote) {
              this.form.result += "\n" + response.data.excel_remote;
            }
            if (response.data.word_remote) {
              this.form.result += "\n" + response.data.word_remote;
            }
            if (response.data.pdf_remote) {
              this.form.result += "\n" + response.data.pdf_remote;
            }
          })
          .catch(error => {
            console.log(error);
            if (this.failedNum > 5) {
              clearInterval(progressRunner);
              this.showProgress = false;
              this.form.result += `Network Error: ${error.message}. Please try again! `;
            }
            this.failedNum++;
          });
      }, 1200);
    }
  },
  computed: {
    /** Submit button disable status validation by all field required. */
    submitBtnValidate() {
      // Disable if PDF processing is active
      if (this.isProcessingActive) {
        return false;
      }

      if (
        this.form.fileName.trim() &&
        this.form.maxSize &&
        this.$_excelFile &&
        this.$_excelFile.name &&
        /^[0-9]+$/.test(this.form.maxSize) &&
        this.$_excelFile.name.includes(".xlsx")
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/form.scss";
@import "callia-ui-box/src/assets/scss/styles.scss";

.card {
  width: 100%;
  border: none;
}

.report-label {
  font-weight: 600;

  .weight {
    font-weight: 400;
  }

  span {
    font-weight: 400;
  }
}

#order-reports {
  position: relative;
}

// Waybill Processing Styles
.processing-alert {
  .alert {
    border-radius: 4px;

    .spinner-border {
      margin-right: 12px;
    }

    .progress {
      margin-top: 8px;
      background-color: rgba(0, 0, 0, 0.05);
    }

    p {
      font-size: 0.875rem;
      margin: 4px 0 0 0;
    }
  }
}

.error-alerts {
  .alert {
    border-radius: 4px;
    border-left: 4px solid #ffc107;
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }

    .btn-close {
      padding: 0.25rem;
    }
  }
}

.preview-card {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 18px;
}

.pdf-preview-wrapper {
  border: 1px solid #dee2e6;
  border-radius: 6px;
  overflow: hidden;
  min-height: 520px;
}

.pdf-preview-iframe {
  width: 100%;
  min-height: 520px;
  height: 100%;
}
</style>
